var $config = {
  feathersServer: 'https://api-lb.livecasthq.com',
  uploadServer: 'https://api-lb.livecasthq.com/upload',
  twilioBaseUrl: 'https://api-lb.livecasthq.com/audio'
  // 'feathersServer': "http://18.157.186.241:3030",
  // 'feathersServer': "http://18.157.186.241:3030",
  // 'uploadServer': "http://18.157.186.241:3030/upload",
  // 'uploadServer': "167.99.244.170/upload"
  // feathersServer: 'http://localhost:3030'
  // 'uploadServer': "http://localhost:3030/upload",
  // 'twilioBaseUrl': " http://localhost:3030/audio",
  // 'twilioBaseUrl': "https://8b489695.eu.ngrok.io/audio",

  // 'uploadServer': "localhost:3030/upload",
}

export default $config
